<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <!-- 修改物流单号对话框 -->
    <el-dialog
      title="修改物流单号"
      :visible.sync="expressNoForm.dialogVisible"
      width="30%"
    >
      <el-form size="small">
        <el-form-item label="物流单号">
          <el-input v-model="expressNoForm.express_no"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="expressNoForm.dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="updateExpressNo">确 定</el-button>
      </span>
    </el-dialog>
    <!--订单进度-->
    <!-- <el-steps :active="active" finish-status="success">
        <el-step title="下单时间"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="发货"></el-step>
        <el-step title="收货"></el-step>
        <el-step title="完成"></el-step>
        </el-steps> -->
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">买家：</span>
              {{
                detail.user && detail.user.nickName ? detail.user.nickName : ""
              }}
              <span v-if="detail.user"
                >用户ID：({{ detail.user.user_id }})</span
              >
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单金额 (元)：</span>
              {{ detail.order_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">运费金额 (元)：</span>
              {{ detail.express_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">实付款金额 (元)：</span>
              {{ detail.pay_price }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">支付方式：</span>
              {{ detail.pay_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">配送方式：</span>
              {{ detail.delivery_type.text }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">发货仓库：</span>
             <span v-if="detail.logistics && detail.logistics.name "> {{ detail.logistics.name }}({{ detail.logistics.logistics_id }}) </span>
             <span v-else> 平台 </span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">交易状态：</span>
              {{ detail.order_status.text }}
            </div>
          </el-col>
          <el-col
            :span="5"
            v-if="
              detail['pay_status']['value'] == 10 &&
                detail['order_status']['value'] == 10 &&
                detail['order_source'] == 10
            "
            v-auth="'/order/order/updatePrice'"
          >
            <el-button @click="editClick(detail)" size="small"
              >修改价格</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!--编辑-->
      <Add
        v-if="open_edit"
        :open_edit="open_edit"
        :order="userModel"
        @close="closeDialogFunc($event, 'edit')"
      ></Add>

      <!--商品信息-->
      <div class="common-form mt16">商品信息</div>
      <div class="table-wrap">
        <el-table
          size="small"
          :data="detail.product"
          border
          style="width: 100%"
        >
          <el-table-column prop="product_name" label="商品" width="400">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img v-img-url="scope.row.image.file_path" />
                </div>
                <div class="info">
                  <div class="name">{{ scope.row.product_name }}</div>
                  <div class="gray9" v-if="scope.row.product_attr != ''">
                    {{ scope.row.product_attr }}
                  </div>
                  <div class="price">
                    <span
                      :class="{
                        'text-d-line': scope.row.is_user_grade == 1,
                        gray6: scope.row.is_user_grade != 1
                      }"
                      >￥ {{ scope.row.product_price }}</span
                    >
                    <span class="ml10" v-if="scope.row.is_user_grade == 1">
                      会员折扣价：￥ {{ scope.row.grade_product_price }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_no" label="商品编码"></el-table-column>
          <el-table-column
            prop="product_weight"
            label="重量 (Kg)"
          ></el-table-column>
          <el-table-column prop="total_num" label="购买数量">
            <template slot-scope="scope">
              <p>x {{ scope.row.total_num }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="total_price" label="商品总价(元)">
            <template slot-scope="scope">
              <p>￥ {{ scope.row.total_price }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--收货信息-->
      <div v-if="detail.delivery_type.value == 10 && detail.address">
        <div class="common-form mt16">收货信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货人：</span>
                {{ detail.address.name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货电话：</span>
                {{ detail.address.phone }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货地址：</span>
                {{detail.address.region.province}}  {{detail.address.region.city}} {{detail.address.region.region}}  {{detail.address.region.street}}  {{ detail.address.detail }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>


       <!-- 尺寸信息 -->
        <div class="common-form mt16" v-if="detail.sizeinfo">尺寸信息</div>
        <div class="table-wrap" v-if="detail.sizeinfo">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">学生姓名：</span>
                {{ detail.sizeinfo.student_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.sizeinfo.phone }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">性别：</span>
                {{ detail.sizeinfo.gender }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">年级：</span>
                {{ detail.sizeinfo.grade }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">班级：</span>
                {{ detail.sizeinfo.class_name }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">体型：</span>
                {{ detail.sizeinfo.body_type }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">实际身高 (cm)：</span>
                {{detail.sizeinfo.height}}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">实际体重 (kg)：</span>
                {{detail.sizeinfo.weight}}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">实际胸围 (cm)：</span>
                {{detail.sizeinfo.chest}}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">实际腰围 (cm)：</span>
                {{detail.sizeinfo.waist}}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">实际臀围 (cm)：</span>

                {{detail.sizeinfo.hip}}
              </div>
            </el-col>
          </el-row>
        </div>



      <!--自提门店信息-->
      <template v-if="detail.delivery_type.value == 20">
        <div class="common-form mt16">自提用户信息</div>
        <div class="table-wrap" v-if="detail.extract">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.extract.linkman }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.extract.phone }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">预约时间：</span>
                {{ detail.reserve_date ? detail.reserve_date : "" }}
                {{ detail.reserve_time ? detail.reserve_time : "" }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="common-form mt16">自提信息</div>
        <div class="table-wrap" v-if="detail.extract">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">门店ID：</span>
                {{ detail.extractStore.store_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">门店名称：</span>
                {{ detail.extractStore.store_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.extractStore.linkman }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.extractStore.phone }}
              </div>
            </el-col>
            <el-col :span="15">
              <div class="pb16">
                <span class="gray9">门店地址：</span>
                {{ detail.extractStore.region.province }}- {{ detail.extractStore.region.city }}- {{ detail.extractStore.region.region }}-
                {{ detail.extractStore.address }}
              </div>
            </el-col>
          </el-row>
        </div>
        <!--<div class="common-form mt16">配送信息</div>-->
        <div class="table-wrap" v-if="detail.extract">
          <div v-if="Number(detail.delivery_status.value) === 10">
            <!-- 未发货 -->
            <div class="common-form mt16">配送</div>
            <el-form size="small" label-width="100px">
              <el-form-item label="配送员">
                <div class="d-s-s d-c">
                  <el-button @click="openGetUser" icon="el-icon-plus"
                    >选择配送员</el-button
                  >
                  <ul class="d-s-s select-user">
                    <li
                      class="mr10 d-c-c d-c p-10-0"
                      v-for="(item, index) in select_list"
                      :key="index"
                    >
                      <img
                        :src="item.user.avatarUrl"
                        v-if="item.user && item.user.avatarUrl"
                        class="radius"
                        width="30"
                        height="30"
                      />
                      <p
                        class="lh18 ww100 text-ellipsis"
                        v-if="item.user && item.user.nickName"
                      >
                        {{ item.user.nickName }}
                      </p>
                    </li>
                  </ul>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <!--            <div class="common-form mt16">配送信息</div>-->
            <!--            <div class="table-wrap">-->
            <!--              <el-row>-->
            <!--                <el-col :span="5">-->
            <!--                  <div class="pb16">-->
            <!--                    <span class="gray9">配送员：</span>-->
            <!--                    <img :src="detail.deliveryStaffUser.user.avatarUrl" class="radius" width="30" height="30" />-->
            <!--                    {{detail.deliveryStaffUser ? detail.deliveryStaffUser.name : detail.deliveryStaffUser.user.nickName }}-->
            <!--                  </div>-->
            <!--                </el-col>-->
            <!--                &lt;!&ndash; todo 配送订单时间 &ndash;&gt;-->
            <!--                <el-col :span="5">-->
            <!--                  <div class="pb16">-->
            <!--                    <span class="gray9">开始配送时间：</span>-->
            <!--                    {{ detail.delivery_time }}-->
            <!--                  </div>-->
            <!--                </el-col>-->
            <!--                <el-col :span="5">-->
            <!--                  <div class="pb16">-->
            <!--                    <span class="gray9">配送完成时间：</span>-->
            <!--                    {{ detail.delivery_time }}-->
            <!--                  </div>-->
            <!--                </el-col>-->
            <!--              </el-row>-->
            <!--            </div>-->
          </div>
        </div>
      </template>

      <!--无需发货-->
      <template v-if="detail.delivery_type.value == 30">
        <div class="common-form mt16">用户信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系手机：</span>
                {{ detail.user.mobile }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="25">
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyer_remark }}
              </div>
            </el-col>
          </el-row>
        </div>
      </template>

      <!--付款信息-->
      <div class="table-wrap" v-if="detail.pay_status.value == 20">
        <div class="common-form mt16">付款信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">应付款金额：</span>
                {{ detail.pay_price }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付方式：</span>
                {{ detail.pay_type.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">支付流水号：</span>
                {{ detail.transaction_id }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款状态：</span>
                {{ detail.pay_status.text }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">付款时间：</span>
                {{ detail.pay_time }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!--  用户取消订单 -->
      <div
        v-if="detail.pay_status.value == 20 && detail.order_status.value == 21"
        v-auth="'/order/order/operate/confirmCancel'"
      >
        <div class="common-form mt16">用户取消订单</div>
        <p class="red pb16">
          当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。
        </p>
        <el-form size="small" ref="forms" :model="forms">
          <el-form-item label="审核状态">
            <div>
              <el-radio v-model="forms.is_cancel" :label="1">同意</el-radio>
              <el-radio v-model="forms.is_cancel" :label="0">拒绝</el-radio>
            </div>
          </el-form-item>

          <!-- <el-form-item><el-button type="primary" @click="confirmCancel()">确认审核</el-button></el-form-item> -->
        </el-form>
      </div>

      <!--发货信息-->
      <div
        v-if="
          detail.pay_status.value == 20 &&
            detail.delivery_type.value == 10 &&
            [20, 21].indexOf(detail.order_status.value) === -1
        "
        v-auth="'/order/order/delivery'"
      >
        <div v-if="detail.delivery_status.value == 10">
          <!-- 去发货 -->
          <div class="common-form mt16">去发货</div>
          <el-form size="small" ref="form" :model="form" label-width="100px">
            <el-form-item label="发货时间">
              {{ detail.delivery_time }}
            </el-form-item>
            <el-form-item label="物流公司">
              <el-select v-model="form.express_id" placeholder="请选择快递公司">
                <el-option
                  :label="item.express_name"
                  v-for="(item, index) in expressList"
                  :key="index"
                  :value="item.express_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="物流单号">
              <el-input v-model="form.express_no" class="max-w460"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-else>
          <div class="common-form mt16">发货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流公司：</span>
                  {{
                    detail.express
                      ? detail.express.express_name
                      : detail.express_company
                  }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">物流单号：</span>
                  {{ detail.express_no }}
                  <el-button
                    v-if="
                      (supply_id > 0 && supply_setting.order_send > 0) ||
                        supply_id == 0
                    "
                    size="mini"
                    type="text"
                    @click="openExpressNoDialog"
                  >
                    修改
                  </el-button>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货状态：</span>
                  {{ detail.delivery_status.text }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">发货时间：</span>
                  {{ detail.delivery_time }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!--门店自提核销-->
      <div
        v-if="
          detail.delivery_type.value == 20 &&
            detail.pay_status.value == 20 &&
            (detail.order_status.value != 21 || detail.order_status.value != 20)
        "
        v-auth="'/order/order/operate/extract'"
      >
        <div class="common-form mt16">门店自提核销</div>
        <div v-if="detail.delivery_status.value == 10">
          <el-form
            size="small"
            ref="extract_form"
            :model="extract_form"
            label-width="100px"
          >
            <el-form-item label="门店核销员">
              <el-select
                v-model="extract_form.order.extract_clerk_id"
                placeholder="点击选择"
              >
                <el-option
                  :label="item.real_name"
                  v-for="(item, index) in shopClerkList"
                  :key="item.clerk_id"
                  :value="item.clerk_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="买家取货状态 ">
              <el-radio v-model="extract_form.order.extract_status" :label="1"
                >已取货</el-radio
              >
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onExtract(detail.order_id)"
                >确认核销</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div v-else class="table-wrap">
          <template v-if="detail.extractClerk">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">自提门店名称：</span>
                  {{ detail.extractStore.store_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销员：</span>
                  {{ detail.extractClerk.real_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销状态：</span>
                  <template v-if="detail.delivery_status.value == 20">
                    已核销
                  </template>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">核销时间：</span>
                  {{ detail.delivery_time }}
                </div>
              </el-col>
            </el-row>
          </template>
        </div>
      </div>
    </div>

    <!--分佣信息-->
    <div
      class="common-form mt16"
      v-if="detail.agent_log && detail.agent_log.length"
    >
      分佣信息
    </div>
    <div
      class="table-wrap agent_log"
      v-if="detail.agent_log && detail.agent_log.length"
    >
      <el-table
        size="small"
        :data="detail.agent_log"
        border
        style="width: 100%"
      >
        <el-table-column prop="log_type.text" label="类型"></el-table-column>
        <el-table-column prop="user" label="用户">
          <template slot-scope="scope">
            <div class="user d-s-c d-r">
              <div class="pic">
                <img
                  v-img-url="scope.row.user.avatarUrl"
                  width="40"
                  height="40"
                />
              </div>
              <div class="ml10">
                <div class="name">
                  {{ scope.row.user.nickName }} ({{ scope.row.user.user_id }})
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="佣金"></el-table-column>
        <el-table-column prop="is_settled" label="结算状态">
          <template slot-scope="scope">
            <span v-if="scope.row.is_settled" class="green">已结算</span>
            <span v-else class="gray9">未结算</span>
          </template>
        </el-table-column>
        <el-table-column prop="settle_time" label="结算时间"></el-table-column>
      </el-table>
    </div>

    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc"
        >返回上一页</el-button
      >
      <!--确认发货-->
      <template
        v-if="
          detail.pay_status.value == 20 &&
            detail.delivery_type.value == 10 &&
            [20, 21].indexOf(detail.order_status.value) === -1 &&
            ((supply_id > 0 && supply_setting.order_send > 0) || supply_id == 0)
        "
      >
        <el-button
          size="small"
          type="primary"
          @click="onSubmit"
          v-if="detail.delivery_status.value == 10"
          >确认发货</el-button
        >
      </template>
      <!--用户取消-->
      <template
        v-if="
          detail.pay_status.value == 20 &&
            detail.order_status.value == 21 &&
            ((supply_id > 0 && supply_setting.order_send > 0) || supply_id == 0)
        "
      >
        <el-button size="small" type="primary" @click="confirmCancel()"
          >确认审核</el-button
        >
      </template>
      <!--配送-->
      <template
        v-if="
          Number(detail.delivery_type.value) === 20 &&
            Number(detail.delivery_status.value) === 10
        "
      >
        <el-button size="small" type="primary" @click="confirmDelivery"
          >确认配送</el-button
        >
      </template>
      <!--计算佣金，只支付后台导入的订单-->
      <template
        v-if="
          detail.is_import == 1 &&
            detail.agent_log_status == 0 &&
            detail.is_agent == 1 &&
            detail.pay_status.value == 20 &&
            detail.delivery_status.value == 20 &&
            detail.receipt_status.value == 20 &&
            detail.order_status.value == 30
        "
      >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-check"
          @click="addAgentOrder(detail)"
          v-auth="'/order/order/addAgentOrder'"
          >计算佣金</el-button
        >
      </template>
      <!--结算佣金，只支付后台导入的订单-->
      <template v-if="detail.is_import == 1 && detail.agent_log_status == 10">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-check"
          @click="settled(detail)"
          v-auth="'/order/order/settled'"
          >结算佣金</el-button
        >
      </template>
    </div>

    <!--选择用户-->
    <deliveryUser
      :storeId="Number(form.store_id)"
      :is_open="isOpenGetUser"
      :multi="false"
      @close="closeGetUserFunc"
    ></deliveryUser>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Add from "./dialog/Add.vue";
import deliveryUser from "@/components/user/deliveryUser";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    Add,
    deliveryUser
  },
  data() {
    return {
      expressNoForm: {
        express_no: "",
        dialogVisible: false
      },
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      detail: {
        pay_status: [],
        pay_type: [],
        delivery_type: [],
        user: {},
        address: [],
        product: [],
        order_status: [],
        extract: [],
        extract_store: [],
        express: [],
        delivery_status: [],
        extractClerk: [],
        delivery_warehouse: ""
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        express_id: null,
        /*订单号*/
        express_no: ""
      },
      forms: {
        is_cancel: 1
      },
      extract_form: {
        order: {
          extract_status: 1
        }
      },
      order: {},
      delivery_type: 0,
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {},
      /*时间*/
      create_time: "",
      /*快递公司列表*/
      expressList: [],
      shopClerkList: [],
      /*是否打开编辑弹窗*/
      open_edit: false,
      supply_id: 0,
      // 选择用户flag
      isOpenGetUser: false,
      // 选择的配送员列表,只有一个
      select_list: [],
      deliveryForm: {}
    };
  },
  created() {
    /*获取列表*/
    this.getParams();
  },
  methods: {
    // 打开修改物流单号对话框
    openExpressNoDialog() {
      console.log("1111111111111111233456");
      this.expressNoForm = {
        express_no: this.detail.express_no,
        dialogVisible: true
      };
    },
    // 更新物流单号
    updateExpressNo() {
      let self = this;
      let order_id = this.$route.query.order_id;
      console.log("当前物流单号:", this.expressNoForm.express_no); // 调试用
      OrderApi.updateExpressNo(
        {
          order_id: order_id,
          express_no: this.expressNoForm.express_no
        },
        true
      )
        .then(data => {
          self.$message.success("修改成功");
          self.expressNoForm.dialogVisible = false;
          self.getParams();
        })
        .catch(error => {
          self.$message.error(error.msg || "修改失败");
        });
    },
    next() {
      if (this.active++ > 4) this.active = 0;
    },
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.order_id;
      OrderApi.orderdetail({
        order_id: params,
        XDEBUG_SESSION_START: "PHPSTORM"
      })
        .then(data => {
          self.loading = false;
          self.detail = data.data.detail;
          self.expressList = data.data.expressList;
          self.shopClerkList = data.data.shopClerkList;

          if (data.data.supply) {
            self.supply = data.data.supply;
            self.supply_id = self.supply.supply_id;
            self.supply_setting = data.data.supply.kmd_grade.setting;
          } else {
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*发货*/
    onSubmit() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error("请选择物流公司");
        return;
      }
      if (param.express_no == "") {
        this.$message.error("请填写物流单号");
        return;
      }
      let order_id = this.$route.query.order_id;
      OrderApi.delivery(
        {
          param: param,
          order_id: order_id
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，发货成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*确认取消*/
    confirmCancel() {
      let self = this;
      let order_id = this.$route.query.order_id;
      let is_cancel = self.forms.is_cancel;
      OrderApi.confirm(
        {
          order_id: order_id,
          is_cancel: is_cancel
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，审核成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*核销*/
    onExtract(e) {
      let self = this;
      let extract_form = self.extract_form;
      extract_form.order_id = e;
      OrderApi.extract(
        {
          extract_form
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，操作成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        this.getParams();
      }
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开获取用户*/
    openGetUser() {
      this.isOpenGetUser = true;
    },
    /*关闭获取用户*/
    closeGetUserFunc(e) {
      if (e.type != "error") {
        this.select_list = [e.params];
      }
      this.isOpenGetUser = false;
    },
    // 确认配送
    confirmDelivery() {
      // select_list
      // if (!Array.isArray(this.select_list)) {
      //   this.$message.error('请选择配送员')
      //   return false
      // }
      // if (this.select_list.length === 0) {
      //   this.$message.error('请选择配送员')
      //   return false
      // }
      let self = this;
      let order_id = this.$route.query.order_id;
      // let deliveryStaffId = self.select_list[0].delivery_staff_id;
      OrderApi.deliveryStaff({
        order_id: order_id
        // deliveryStaffId: deliveryStaffId,
        // XDEBUG_SESSION_START: 'PHPSTORM',
      })
        .then(data => {
          self.loading = false;
          self.$message({
            message: "配送成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*计算佣金*/
    addAgentOrder() {
      let self = this;
      let order_id = this.$route.query.order_id;
      self
        .$confirm("此操作将【确认计算佣金】, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          OrderApi.addAgentOrder({ order_id: order_id }, true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: res.msg,
                type: "success"
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    },

    /*确认结算佣金*/
    settled() {
      let self = this;
      let order_id = this.$route.query.order_id;
      self
        .$confirm("此操作将【确认结算佣金】, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          OrderApi.settled({ order_id: order_id }, true)
            .then(res => {
              self.loading = false;
              self.$message({
                message: res.msg,
                type: "success"
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/detail.vue